import React from 'react'
import { Form, Modal, Input, Typography } from '@pankod/refine-antd'

import { MaskedTextInput } from '@components/MaskedTextInput'

const { Text } = Typography

export type TSignFormValues = {
  'bsre-nik': string
  'bsre-phrase': string
}

// --- Approve Modal ---
interface TApproveModalProps {
  open: boolean
  namaDiklat?: string
  onClose: () => void
  onConfirm: () => void
}

export const ApproveModal: React.FC<TApproveModalProps> = ({
  open,
  namaDiklat,
  onClose,
  onConfirm,
}) => (
  <Modal
    open={open}
    title="Konfirmasi Persetujuan"
    okText="Ya, Setujui"
    cancelText="Batal"
    okButtonProps={{ type: 'primary' }}
    onOk={onConfirm}
    onCancel={onClose}
    destroyOnClose
  >
    <p>
      Apakah Anda yakin ingin menyetujui pengajuan penerbitan sertifikat untuk{' '}
      <strong>{namaDiklat}</strong>?
    </p>
  </Modal>
)

// --- Sign Modal ---
interface TSignModalProps {
  open: boolean
  namaDiklat?: string
  onClose: () => void
  onConfirm: (
    values: TSignFormValues,
    setFieldError: (name: string, error: string) => void,
  ) => void
}

export const SignModal: React.FC<TSignModalProps> = ({
  open,
  namaDiklat,
  onClose,
  onConfirm,
}) => {
  const [form] = Form.useForm()

  return (
    <Modal
      open={open}
      title="Konfirmasi Tanda Tangan"
      okText="Ya, Tandatangani"
      cancelText="Batal"
      okButtonProps={{ type: 'primary' }}
      onOk={() => form.submit()}
      onCancel={() => {
        form.resetFields()
        onClose()
      }}
      afterClose={() => form.resetFields()}
      destroyOnClose
    >
      <p>
        Apakah Anda yakin ingin menandatangani sertifikat untuk{' '}
        <strong>{namaDiklat}</strong>? Tanda tangan elektronik akan diajukan ke
        BSrE.
      </p>
      <Form
        form={form}
        layout="vertical"
        onFinish={(values) => {
          onConfirm(values, (name, error) => {
            form.setFields([{ name, errors: [error] }])
          })
        }}
        style={{ marginTop: 16 }}
      >
        <Form.Item
          label={<Text strong>NIK</Text>}
          name="bsre-nik"
          rules={[
            { required: true, message: 'NIK wajib diisi' },
            {
              len: 16,
              message: 'NIK harus berjumlah tepat 16 digit',
            },
            {
              pattern: /^[0-9]+$/,
              message: 'NIK hanya boleh berisi angka',
            },
          ]}
        >
          <Input
            placeholder="Masukkan NIK"
            maxLength={16}
            autoComplete="off"
            autoCorrect="off"
            id="bsre-nik"
            name="bsre-nik"
          />
        </Form.Item>
        <Form.Item
          label={<Text strong>Passphrase</Text>}
          name="bsre-phrase"
          rules={[{ required: true, message: 'Passphrase wajib diisi' }]}
        >
          <MaskedTextInput
            placeholder="Masukkan Passphrase"
            id="bsre-phrase"
            name="bsre-phrase"
          />
        </Form.Item>
      </Form>
    </Modal>
  )
}

// --- Reject Modal ---
interface TRejectModalProps {
  open: boolean
  namaDiklat?: string
  rejectReason: string
  setRejectReason: (val: string) => void
  onClose: () => void
  onConfirm: () => void
}

export const RejectModal: React.FC<TRejectModalProps> = ({
  open,
  namaDiklat,
  rejectReason,
  setRejectReason,
  onClose,
  onConfirm,
}) => (
  <Modal
    open={open}
    title="Konfirmasi Penolakan"
    okText="Ya, Tolak"
    cancelText="Batal"
    okButtonProps={{
      danger: true,
      disabled: rejectReason.trim() === '',
    }}
    onOk={onConfirm}
    onCancel={onClose}
    destroyOnClose
  >
    <p>
      Anda akan menolak pengajuan sertifikat untuk <strong>{namaDiklat}</strong>
      .
    </p>
    <div style={{ marginTop: 12 }}>
      <div style={{ marginBottom: 4 }}>
        <Text strong>
          Alasan Penolakan <Text type="danger">*</Text>
        </Text>
      </div>
      <Input.TextArea
        rows={4}
        placeholder="Masukkan alasan penolakan..."
        value={rejectReason}
        onChange={(e) => setRejectReason(e.target.value)}
      />
    </div>
  </Modal>
)
